import Spacer from '$tablet-app/src/app/components/Spacer';
import { Button } from '@akin-home/buttons/native';
import { TextInput } from '@akin-home/forms/native';
import { Text } from '@akin-home/text/native';
import { useState } from 'react';
import styled from 'styled-components/native';

type Props = {
  username?: string;
  onPressSendCode(username: string): void;
};

export function ForgotPasswordEnterUsernameForm(props: Props) {
  const [username, setUsername] = useState(props.username || '');

  function onPressSend() {
    props.onPressSendCode(username);
  }

  return (
    <Container>
      <Text>Enter your user name. You will be sent a reset code</Text>
      <Spacer height="15px" />
      <TextInput
        placeholder="Username"
        value={username}
        onChangeText={setUsername}
      />
      <Button size="large" onPress={onPressSend}>
        Send code
      </Button>
    </Container>
  );
}

const Container = styled.View`
  gap: 15px;
  max-width: 500px;
  width: 100%;
  justify-content: center;
  align-self: center;
`;
